import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useMarketing() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/employee/")
    .then((res: SuccessFetch<{
      payload: {
        employee_id: number
        employee_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.employee_name, value: item.employee_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/employee/")
    .then((res: SuccessFetch<{
      payload: {
        employee_id: number
        employee_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.employee_name, value: item.employee_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}